import { LcrShadowStateReportV1Schema } from "./londonCareRecord.js";
const pdfTemplateVersion = "lcr-report-v1";
const assigningAuthorityOid = "1.2.826.0.1285.A";
const patient = {
    id: "00000000-c717-4ddd-89f5-d6e1489a8831",
    nhsNumber: "973 633 3906",
    name: { given: "Zane", family: "Bridges" },
    dateOfBirth: "2000-01-01",
};
const detainingOrganisations = [
    {
        hospital: { name: "Hospital A" },
        trust: { name: "Trust A" },
    },
    {
        hospital: { name: "Hospital B" },
        trust: { name: "Trust B" },
    },
];
export const exampleLcrReport_v1_Data = {
    section2: [
        {
            data: LcrShadowStateReportV1Schema.shape.entityData.parse({
                assigningAuthorityOid,
                pdfTemplateVersion,
                patient,
                mhaStatus: {
                    identifier: "Section 2",
                    startDateTime: "2023-01-01T00:00:00.000Z",
                    endDateTime: "2023-02-01T00:00:00.000Z",
                    detainingOrganisations,
                    completionStatus: "active",
                },
            }),
        },
    ],
    section3: [
        {
            data: LcrShadowStateReportV1Schema.shape.entityData.parse({
                assigningAuthorityOid,
                pdfTemplateVersion,
                patient,
                mhaStatus: {
                    identifier: "Section 3",
                    startDateTime: "2023-01-01T00:00:00.000Z",
                    endDateTime: "2023-02-01T00:00:00.000Z",
                    detainingOrganisations,
                    completionStatus: "active",
                },
            }),
        },
    ],
    cto: [
        {
            data: LcrShadowStateReportV1Schema.shape.entityData.parse({
                assigningAuthorityOid,
                pdfTemplateVersion,
                patient,
                mhaStatus: {
                    identifier: "CTO",
                    startDateTime: "2023-01-01T00:00:00.000Z",
                    endDateTime: "2023-02-01T00:00:00.000Z",
                    detainingOrganisations,
                    completionStatus: "active",
                },
            }),
        },
    ],
    section4: [
        {
            data: LcrShadowStateReportV1Schema.shape.entityData.parse({
                assigningAuthorityOid,
                pdfTemplateVersion,
                patient,
                mhaStatus: {
                    identifier: "Section 4",
                    startDateTime: "2023-01-01T00:00:00.000Z",
                    endDateTime: "2023-02-01T00:00:00.000Z",
                    detainingOrganisations,
                    completionStatus: "active",
                },
            }),
        },
    ],
    section5_2: [
        {
            data: LcrShadowStateReportV1Schema.shape.entityData.parse({
                assigningAuthorityOid,
                pdfTemplateVersion,
                patient,
                mhaStatus: {
                    identifier: "Section 5(2)",
                    startDateTime: "2023-01-01T00:00:00.000Z",
                    endDateTime: "2023-02-01T00:00:00.000Z",
                    detainingOrganisations,
                    completionStatus: "active",
                },
            }),
        },
    ],
    section5_4: [
        {
            data: LcrShadowStateReportV1Schema.shape.entityData.parse({
                assigningAuthorityOid,
                pdfTemplateVersion,
                patient,
                mhaStatus: {
                    identifier: "Section 5(4)",
                    startDateTime: "2023-01-01T00:00:00.000Z",
                    endDateTime: "2023-02-01T00:00:00.000Z",
                    detainingOrganisations,
                    completionStatus: "active",
                },
            }),
        },
    ],
    section136: [
        {
            data: LcrShadowStateReportV1Schema.shape.entityData.parse({
                assigningAuthorityOid,
                pdfTemplateVersion,
                patient,
                mhaStatus: {
                    identifier: "Section 136",
                    // 24h detention window — rendered with time (dd/mm/yyyy hh:mm)
                    startDateTime: "2023-01-01T09:30:00.000Z",
                    endDateTime: "2023-01-02T09:30:00.000Z",
                    // For Section 136 the "hospital" is the Place of Safety name and the
                    // "trust" is the trust associated with that Place of Safety. Two are
                    // listed here to verify the whole set renders (newest at the top),
                    // while the single police force is listed once at the status level.
                    detainingOrganisations: [
                        {
                            hospital: { name: "St Pancras Place of Safety" },
                            trust: { name: "Trust A" },
                        },
                        {
                            hospital: { name: "Royal London Hospital" },
                            trust: { name: "Trust B" },
                        },
                    ],
                    policeForce: { name: "Metropolitan Police" },
                    completionStatus: "active",
                },
            }),
        },
    ],
    notDetained: [
        {
            data: LcrShadowStateReportV1Schema.shape.entityData.parse({
                assigningAuthorityOid,
                pdfTemplateVersion,
                patient,
                mhaStatus: {
                    identifier: "Section 2",
                    startDateTime: "2023-01-01T00:00:00.000Z",
                    endDateTime: "2023-02-01T00:00:00.000Z",
                    detainingOrganisations,
                    completionStatus: "not-detained",
                },
            }),
        },
    ],
    transferredOutOfScope: [
        {
            data: LcrShadowStateReportV1Schema.shape.entityData.parse({
                assigningAuthorityOid,
                pdfTemplateVersion,
                patient,
                mhaStatus: {
                    identifier: "Section 2",
                    startDateTime: "2023-01-01T00:00:00.000Z",
                    endDateTime: "2023-02-01T00:00:00.000Z",
                    detainingOrganisations,
                    completionStatus: "transferred-out-of-scope",
                },
            }),
        },
    ],
    expired: [
        {
            data: LcrShadowStateReportV1Schema.shape.entityData.parse({
                assigningAuthorityOid,
                pdfTemplateVersion,
                patient,
                mhaStatus: {
                    identifier: "Section 2",
                    startDateTime: "2023-01-01T00:00:00.000Z",
                    endDateTime: "2023-02-01T00:00:00.000Z",
                    detainingOrganisations,
                    completionStatus: "expired",
                },
            }),
        },
    ],
    unknownIncomplete: [
        {
            data: LcrShadowStateReportV1Schema.shape.entityData.parse({
                assigningAuthorityOid,
                pdfTemplateVersion,
                patient,
                mhaStatus: {
                    identifier: "Section 2",
                    startDateTime: "2023-01-01T00:00:00.000Z",
                    endDateTime: "2023-02-01T00:00:00.000Z",
                    detainingOrganisations,
                    completionStatus: "unknown-incomplete",
                },
            }),
        },
    ],
};
//# sourceMappingURL=pdfExampleData.js.map